interface GlyphProps {
  size?: number;
  className?: string;
}

const Svg = ({ size = 20, className, children }: GlyphProps & { children: React.ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={["qai-glyph", className].filter(Boolean).join(" ")}
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const CreateGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <rect x="4" y="4" width="16" height="16" rx="3" />
    <path d="M12 9v6" />
    <path d="M9 12h6" />
  </Svg>
);

export const ImportGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <path d="M12 15.5V4.5" />
    <path d="M8 8.25 12 4.25l4 4" />
    <path d="M4.5 15.5v2.75a1.75 1.75 0 0 0 1.75 1.75h11.5a1.75 1.75 0 0 0 1.75-1.75V15.5" />
  </Svg>
);

export const ArrowGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <path d="M4.5 12h14" />
    <path d="M13 6.5 18.5 12 13 17.5" />
  </Svg>
);

export const ProductsGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <path d="M20 7.5 12 3.5 4 7.5v9l8 4 8-4z" />
    <path d="m4 7.5 8 4 8-4" />
    <path d="M12 11.5v9" />
  </Svg>
);

export const ContactsGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M4.5 19.5a7.5 7.5 0 0 1 15 0" />
  </Svg>
);

export const CategoriesGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
    <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
    <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
    <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
  </Svg>
);

export const AccountsGlyph = (props: GlyphProps) => (
  <Svg {...props}>
    <rect x="4.5" y="3.5" width="15" height="17" rx="2" />
    <path d="M8.5 8h7" />
    <path d="M8.5 12h7" />
    <path d="M8.5 16h4" />
  </Svg>
);
